import { render, staticRenderFns } from "./touchDrainageCardNew.vue?vue&type=template&id=6950c01e&scoped=true"
import script from "./touchDrainageCardNew.vue?vue&type=script&lang=js"
export * from "./touchDrainageCardNew.vue?vue&type=script&lang=js"
import style0 from "./touchDrainageCardNew.vue?vue&type=style&index=0&id=6950c01e&prod&lang=less&scoped=true"
import style1 from "./touchDrainageCardNew.vue?vue&type=style&index=1&id=6950c01e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950c01e",
  null
  
)

export default component.exports